/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Плательщик
 */
export type OrderCreatePayer = {
  /**
   * Кто из участников заявки выступает в роли плательщика
   */
  role: OrderCreatePayer.Role
}
export namespace OrderCreatePayer {
  /**
   * Кто из участников заявки выступает в роли плательщика
   */
  export enum Role {
    CUSTOMER = 'customer',
    DEPARTURE_PARTNER = 'departurePartner',
    DESTINATION_PARTNER = 'destinationPartner'
  }
}
